import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { StyleClassModule } from 'primeng/styleclass';
import { TooltipModule } from 'primeng/tooltip';

@Component({
    selector: 'btn-icon',
    standalone: true,
    imports: [TranslateModule, TooltipModule, ButtonModule, StyleClassModule, CommonModule],
    templateUrl: './button-icon.component.html',
    styleUrl: './button-icon.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonIconComponent {
    id = input.required<string>();
    icon = input.required<string>();
    ariaLabel = input.required<string>();

    tooltip = input<string>('');
    tooltipPosition = input<'bottom' | 'left' | 'right' | 'top'>('top');
    tooltipDisabled = input<boolean>(false);

    severity = input<'success' | 'info' | 'warn' | 'danger' | 'help' | 'primary' | 'secondary' | 'contrast'>('primary');
    size = input<undefined | 'small' | 'large'>(undefined);
    rounded = input<boolean>(true);
    text = input<boolean>(true);
    outlined = input<boolean>(false);

    disabled = input<boolean>(false);
    loading = input<boolean>(false);

    class = input<string>('');

    onClick = output<MouseEvent>();
}
